<template>
  <section class="content">

    <div class="callout callout-info">
      <h4>统计目标主机总量：<span>{{testDeviceList.length}}</span>。</h4>
      <p>因为数据同步的问题，可能在一段时间内，各个统计部分的总量与目标主机总量不相等。</p>
    </div>

    <!--chart-->
    <div class="row">
      <div class="col-md-6">
        <div class="box box-primary">
          <div class="box-header with-border">
            <i class="fa fa-check-circle"></i>
            <h3 class="box-title">Online Data</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="box-body">
            <!--饼图-->
            <div class="chart">
                   <canvas id="areaChart" class="test-device-analysis-chart"></canvas>
            </div>
            <!--饼图-->
            <!--数据-->
            <div class="test-device-analysis-data">
              <table class="test-device-analysis-table">
                <tr>
                  <td><i class="fa fa-check-circle test-device-analysis-table-icon-online"></i>online</td>
                  <td class="test-device-analysis-table-num">{{online}}</td>
                </tr>
                <tr>
                  <td><i class="fa fa-times-circle test-device-analysis-table-icon-offline"></i>offline</td>
                  <td class="test-device-analysis-table-num">{{offline}}</td>
                </tr>
                <tr>
                  <td><i class="fa fa-exclamation-circle test-device-analysis-table-icon-nocoap"></i>no coap connection</td>
                  <td class="test-device-analysis-table-num">{{nocoap}}</td>
                </tr>
                <tr>
                  <td><i class="fa fa-minus-circle test-device-analysis-table-icon-unregistered"></i>unregistered</td>
                  <td class="test-device-analysis-table-num">{{unregister}}</td>
                </tr>
                <tr class="test-device-analysis-table-total">
                  <td class="test-device-analysis-table-padding">TOTAL</td>
                  <td class="test-device-analysis-table-num">{{online + offline + nocoap + unregister}}</td>
                </tr>
              </table>
            </div>
            <!--数据-->
          </div>
          <!-- /.box-body-->
        </div>
        <!-- /.box -->
      </div>
      <div class="col-md-6">
        <div class="box box-primary">
          <div class="box-header with-border">
            <i class="fa fa-signal"></i>
            <h3 class="box-title">Sim Card Data</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="box-body" v-if="(normal + problem + nocard) !== 0">
            <!--饼图-->
            <canvas id="simCardChart" class="test-device-analysis-chart"></canvas>
            <!--饼图-->
            <!--数据-->
            <div class="test-device-analysis-data">
              <table class="test-device-analysis-table">
                <tr>
                  <td><i class="fa fa-check-circle test-device-analysis-table-icon-online"></i>normal</td>
                  <td class="test-device-analysis-table-num">{{normal}}</td>
                </tr>
                <tr>
                  <td><i class="fa fa-exclamation-circle test-device-analysis-table-icon-offline"></i>something wrong</td>
                  <td class="test-device-analysis-table-num">{{problem}}</td>
                </tr>
                <tr>
                  <td><i class="fa fa-times-circle test-device-analysis-table-icon-nocoap"></i>have no card</td>
                  <td class="test-device-analysis-table-num">{{nocard}}</td>
                </tr>
                <tr class="test-device-analysis-table-total">
                  <td class="test-device-analysis-table-padding">TOTAL</td>
                  <td class="test-device-analysis-table-num">{{normal + problem + nocard}}</td>
                </tr>
              </table>
            </div>
            <!--数据-->
          </div>
          <!-- /.box-body-->
          <!--空数据-->
          <div class="box-body" v-else>
            <!--饼图-->
            <p class="test-device-analysis-chart-empty">There is no data now.</p>
            <!--饼图-->
            <!--数据-->
            <div class="test-device-analysis-data">
              <table class="test-device-analysis-table">
                <tr>
                  <td><i class="fa fa-check-circle test-device-analysis-table-icon-online"></i>normal</td>
                  <td class="test-device-analysis-table-num">-</td>
                </tr>
                <tr>
                  <td><i class="fa fa-exclamation-circle test-device-analysis-table-icon-offline"></i>something wrong</td>
                  <td class="test-device-analysis-table-num">-</td>
                </tr>
                <tr>
                  <td><i class="fa fa-times-circle test-device-analysis-table-icon-nocoap"></i>have no card</td>
                  <td class="test-device-analysis-table-num">-</td>
                </tr>
                <tr class="test-device-analysis-table-total">
                  <td class="test-device-analysis-table-padding">TOTAL</td>
                  <td class="test-device-analysis-table-num">-</td>
                </tr>
              </table>
            </div>
            <!--数据-->
          </div>
          <!-- /.box-body-->
          <!--空数据-->
        </div>
        <!-- /.box -->
      </div>

    </div>
    <!--chart-->

  </section>
</template>
<script>
import api from '../../api'
import utils from '../../utils'
import global from '../Global.vue'
import Chart from '../../../static/js/plugins/chartjs/Chart.js'

export default {
  name: 'TestDeviceAnalysis',
  data () {
    return {
      testDeviceList: [],
      online: 0,
      offline: 0,
      nocoap: 0,
      unregister: 0,
      normal: 0,
      problem: 0,
      nocard: 0,
      pieData: [
        {
          value: 0,
          color: '#4AC0C0',
          highlight: '#41A6A6',
          label: 'online'
        },
        {
          value: 0,
          color: '#FF6483',
          highlight: '#E65A76',
          label: 'offline'
        },
        {
          value: 0,
          color: '#36A2EB',
          highlight: '#3091D1',
          label: 'no coap connection'
        },
        {
          value: 0,
          color: '#FFCD56',
          highlight: '#E6B84E',
          label: 'unregistered'
        }
      ],
      simCardChartData: [
        {
          value: 0,
          color: '#4AC0C0',
          highlight: '#41A6A6',
          label: 'normal'
        },
        {
          value: 0,
          color: '#FF6483',
          highlight: '#E65A76',
          label: 'something wrong'
        },
        {
          value: 0,
          color: '#36A2EB',
          highlight: '#3091D1',
          label: 'have no card'
        }
      ]
    }
  },
  created () {
  },
  mounted () {
    this.testDeviceList = ['Deviceid_SikkertHjem_1e89f85acA',
      'Deviceid_SikkertHjem_40E1411f23',
      'Deviceid_SikkertHjem_682fad066a',
      'Deviceid_SikkertHjem_32f2AfB98f',
      'Deviceid_SikkertHjem_25677466Af',
      'Deviceid_SikkertHjem_FD6bE31Cc4',
      'Deviceid_SikkertHjem_F0f122179e',
      'Deviceid_SikkertHjem_7b79969114',
      'Deviceid_SikkertHjem_c81D46d605',
      'Deviceid_SikkertHjem_5a8Cb8ef96',
      'Deviceid_SikkertHjem_0719f41ff9',
      'Deviceid_SikkertHjem_42e188Ccdf',
      'Deviceid_SikkertHjem_4Db6D369F5',
      'Deviceid_SikkertHjem_735d9e9DEa',
      'Deviceid_SikkertHjem_Fdc11Cf718',
      'Deviceid_SikkertHjem_1149E7991B',
      'Deviceid_SikkertHjem_27dd508921',
      'Deviceid_SikkertHjem_89a5AC6E62',
      'Deviceid_SikkertHjem_136E4FdDC0',
      'Deviceid_SikkertHjem_Dde04225d2',
      'Deviceid_SikkertHjem_fFA51BD7d0',
      'Deviceid_SikkertHjem_028fFCD962',
      'Deviceid_SikkertHjem_3680E4D027',
      'Deviceid_SikkertHjem_C0B8896452',
      'Deviceid_SikkertHjem_e56CB6Cb7B',
      'Deviceid_SikkertHjem_c7984CE3B7',
      'Deviceid_SikkertHjem_59Ca9a4a89',
      'Deviceid_SikkertHjem_74dF06038B',
      'Deviceid_SikkertHjem_Ff9fC9eDF6',
      'Deviceid_SikkertHjem_5100bD56d5',
      'Deviceid_SikkertHjem_B8702f89C1',
      'Deviceid_SikkertHjem_536Ac2db2e',
      'Deviceid_SikkertHjem_e51447A6A7',
      'Deviceid_SikkertHjem_33d095A524',
      'Deviceid_SikkertHjem_dE4c280554',
      'Deviceid_SikkertHjem_06B77B1a1c',
      'Deviceid_SikkertHjem_4865de9b5d',
      'Deviceid_SikkertHjem_96550cB152',
      'Deviceid_SikkertHjem_2E32148875',
      'Deviceid_SikkertHjem_5A61C1E2E8',
      'Deviceid_SikkertHjem_292BE0F32e',
      'Deviceid_SikkertHjem_2dA4Ec1Fe2',
      'Deviceid_SikkertHjem_1aA302cE26',
      'Deviceid_SikkertHjem_8952beA672',
      'Deviceid_SikkertHjem_2c5FD5e74A',
      'Deviceid_SikkertHjem_66ae9b3DFd',
      'Deviceid_SikkertHjem_8A70Fc2D57',
      'Deviceid_SikkertHjem_CD5e0a2C3D',
      'Deviceid_SikkertHjem_a1cf0736b4',
      'Deviceid_SikkertHjem_eF87f6D42B',
      'Deviceid_SikkertHjem_976b59F201',
      'Deviceid_SikkertHjem_64CE84bE70',
      'Deviceid_SikkertHjem_81B8136822',
      'Deviceid_SikkertHjem_a7A1b5b569',
      'Deviceid_SikkertHjem_16AB30AC3d',
      'Deviceid_SikkertHjem_836d5Dd121',
      'Deviceid_SikkertHjem_44A02a24f5',
      'Deviceid_SikkertHjem_08CaB3C5dE',
      'Deviceid_SikkertHjem_83a8c50652',
      'Deviceid_SikkertHjem_624587c666']
    this.init()
  },
  beforeDestroy () {
  },
  methods: {
    init () {
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        devices: this.testDeviceList
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.request('post', '/analysis/deviceanalysis?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              var result = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
              this.online = result.online
              this.offline = result.offline
              this.nocoap = result.uncoap
              this.unregister = result.unregister
              this.normal = result.simnormal
              this.problem = result.problem
              this.nocard = result.nocard
              this.initPieData()
              //              console.log(result)
            }
          }
        })
    },
    initPieData () {
      var areaChartOptions = {
        tooltipTemplate: '<%if (label){%><%=label%>: <%}%><%= value %>%'
      }
      var areaChartCanvas = window.jQuery('#areaChart').get(0).getContext('2d')
      var areaChart = new Chart(areaChartCanvas)
      if (this.online > 0) {
        this.pieData[0].value = this.online / this.testDeviceList.length * 100
      }
      if (this.offline > 0) {
        this.pieData[1].value = this.offline / this.testDeviceList.length * 100
      }
      if (this.nocoap > 0) {
        this.pieData[2].value = this.nocoap / this.testDeviceList.length * 100
      }
      if (this.unregister > 0) {
        this.pieData[3].value = this.unregister / this.testDeviceList.length * 100
      }
      areaChart.Pie(this.pieData, areaChartOptions)
      var simCardChartCanvas = window.jQuery('#simCardChart').get(0).getContext('2d')
      var simCardChart = new Chart(simCardChartCanvas)
      if (this.normal > 0) {
        this.simCardChartData[0].value = this.normal / this.testDeviceList.length * 100
      }
      if (this.problem > 0) {
        this.simCardChartData[1].value = this.problem / this.testDeviceList.length * 100
      }
      if (this.nocard > 0) {
        this.simCardChartData[2].value = this.nocard / this.testDeviceList.length * 100
      }
      simCardChart.Pie(this.simCardChartData, areaChartOptions)
    }
  }
}

</script>


<style>
</style>



// WEBPACK FOOTER //
// TestDeviceAnalysis.vue?995c2fe0